/* eslint-disable no-undef */
import axios from "axios";
import React from "react";

const apiURL = process.env.REACT_APP_API_URL;

export const ServicesContext = React.createContext({
  api: {},
});

const ServicesProvider = ({ children }) => {
  const api = axios.create({
    baseURL: apiURL,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("userJWTToken")}`,
      "Timezone-Offset": new Date().getTimezoneOffset(),
    },
  });

  const contextValue = {
    api,
  };

  return (
    <>
      <ServicesContext.Provider value={contextValue}>
        {api && children}
      </ServicesContext.Provider>
    </>
  );
};

export default ServicesProvider;
